import { z } from "zod";
export type CongestionIconType = "face" | "amount" | "symbol" | "symbol2";
export type CongestionState = "vacant" | "moderately_vacant" | "congestion" | "out_of_business_hours";
export type CongestionUpdateResult = "success" | "failure";

export type CongestionSettingDict = z.infer<typeof CongestionSettingDictSchema>;
export const CongestionSettingDictSchema = z.object({
  dict_cd: z.string(),
  // message and contents are synchronized before calling APIs
  message: z.string(), // For query definition
  contents: z.string().optional(), //For BotPartsText component
});

export type CongestionOutOfBusinessHourSetting = z.infer<typeof CongestionOutOfBusinessHourSettingSchema>;
export const CongestionOutOfBusinessHourSettingSchema = z.object({
  out_of_business_hour_setting_id: z.number(),
  from_time: z.string(),
  to_time: z.string(),
  title: CongestionSettingDictSchema,
  description: CongestionSettingDictSchema,
});

export type CongestionSettingIconUnit = z.infer<typeof CongestionSettingIconUnitSchema>;
export const CongestionSettingIconUnitSchema = z.object({
  // CongestionState;
  state: z.enum(["vacant", "moderately_vacant", "congestion", "out_of_business_hours"]),
  icon: z.string(),
});

export type CongestionSettingIcon = z.infer<typeof CongestionSettingIconSchema>;
export const CongestionSettingIconSchema = z.object({
  // CongestionIconType;
  type: z.enum(["face", "amount", "symbol", "symbol2"]),
  icons: z.array(CongestionSettingIconUnitSchema),
});

export type CongestionSettingState = z.infer<typeof CongestionSettingStateSchema>;
export const CongestionSettingStateSchema = z.object({
  // CongestionState;
  state: z.enum(["vacant", "moderately_vacant", "congestion", "out_of_business_hours", ""]),
  number_of_people: z.number(),
  icon: z.string(),
  title: z.string(),
  description: z.string(),
  measured_at: z.string(),
});

export type CongestionIconTitle = z.infer<typeof CongestionIconTitleSchema>;
export const CongestionIconTitleSchema = z.object({
  icon: z.string(),
  title: z.string(),
});

export type CongestionSetting = z.infer<typeof CongestionSettingSchema>;
export const CongestionSettingSchema = z.object({
  facility_id: z.number(),
  facility_name: z.string(),
  congestion_setting_id: z.number().nullable(),
  is_active: z.boolean().nullable(),
  non_active_title: CongestionSettingDictSchema.nullable(),
  non_active_description: CongestionSettingDictSchema.nullable(),
  sensor_id: z.string().nullable(),
  // CongestionIconType;
  icon_type: z.enum(["face", "amount", "symbol", "symbol2"]).nullable(),
  vacant_upper_threshold: z.number().nullable(),
  congestion_lower_threshold: z.number().nullable(),
  sort_key: z.number().nullable(),
  vacant_title: CongestionSettingDictSchema.nullable(),
  vacant_description: CongestionSettingDictSchema.nullable(),
  moderately_vacant_title: CongestionSettingDictSchema.nullable(),
  moderately_vacant_description: CongestionSettingDictSchema.nullable(),
  congestion_title: CongestionSettingDictSchema.nullable(),
  congestion_description: CongestionSettingDictSchema.nullable(),
  congestion_announcement: CongestionSettingDictSchema.nullable(),
  out_of_business_hour_settings: z.array(CongestionOutOfBusinessHourSettingSchema),
  now_state: CongestionSettingStateSchema.nullable(),
});

export type DeleteCongestionSetting = z.infer<typeof DeleteCongestionSettingSchema>;
export const DeleteCongestionSettingSchema = z.object({
  conversation_id: z.string().nullable(),
  default_limit: z.number().nullable(),
  message: z.string().nullable(),
  success: z.boolean(),
  url: z.string().nullable(),
});
